import { createSetting, useDialog } from '@shopex/finder'
import { MessageBox } from 'element-ui'
import ImportDialog from '@/components/importDialog'
import { deleteActivityCodes, updateActivityCodes} from '../api'


const commonAction = [
  { label: '取消', key: 'close', size: 'default' },
  { label: '提交', key: 'save', type: 'primary', size: 'default' }
]

export const tableSetting = (vm) => createSetting({
  columns: [
    {
      name: '国补优惠编码',
      key: 'ums_activity_id',
      minWidth: 130
    },
    {
      name: '国补优惠活动code',
      key: 'ums_discount_code',
      minWidth: 130
    },
    {
      name: '关联商品',
      key: '',
      minWidth: 180,
      render: (h, {row}) => {
        return (
          <div>
            已关联 {row.item_num} 个商品
            <el-button
              style={{ marginLeft: '10px'}}
              type='text'
              on-click={() => vm.showGoods(row)}
            >
              查看
            </el-button>
            <ImportDialog
              buttonName='导入商品'
              buttonSize='medium'
              fileName='导入商品'
              buttonType='text'
              fileType='upload_gov_subsidy_activity_items'
              relId={row.activity_id}
            />
          </div>
        )
      }
    },
    {
      name: '关联经销商',
      key: '',
      minWidth: 200,
      render: (h, {row}) => {
        return (
          <div>
            已关联 {row.dealer_num} 个经销商
            <el-button
              style={{ marginLeft: '10px'}}
              type='text'
              on-click={() => vm.showDealer(row)}
            >
              查看
            </el-button>
            <ImportDialog
              buttonName='导入经销商'
              buttonSize='medium'
              fileName='导入经销商'
              buttonType='text'
              fileType='upload_gov_subsidy_activity_dealer'
              relId={row.activity_id}
            />
          </div>
        )
      }
    }
  ],
  actions: [
    {
      name: '编辑',
      type: 'button',
      buttonType: 'text',
      action: {
        handler: async (rows) => {
          useDialog(null, {
            title: `编辑国补优惠编码`,
            width: '50%',
            orgData: rows[0],
            component: () => import('../comps/createForm.vue'),
            actions: commonAction
          }).then(async (arg) => {
            if(arg) {
              console.log(arg, 'edit_arg')
              let params = {
                ...arg,
                activity_id: rows[0].activity_id
              }
              try {
                await updateActivityCodes(params)
                vm.$message.success('保存成功')
                vm.refresh()
              } catch (error) {
                console.log(error)
              }
            }
          })
        }
      }
    },
    {
      name: '添加商品',
      type: 'button',
      buttonType: 'text',
      action: {
        handler: async (rows) => {
          vm.addItems(rows[0])
        }
      }
    },
    {
      name: '添加经销商',
      type: 'button',
      buttonType: 'text',
      action: {
        handler: async (rows) => {
          vm.addDealerAction(rows[0])
        }
      }
    },
    {
      name: '删除',
      type: 'button',
      buttonType: 'text',
      action: {
        handler: async (rows) => {
          MessageBox.confirm('请确认是否删除当前数据？', '提示').then(async () => {
            const activity_id = rows[0].activity_id
            await deleteActivityCodes({ activity_id })
            vm.$message.success('删除成功')
            vm.refresh()
          })
        }
      }
    },
  ]
})
